import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  AllTableColumn,
  AllTableSorting,
} from '@prlw/core/monitor/types/all-table';
import { Observable } from 'rxjs';
import { AllTableService } from '../all-table.service';

@Component({
  selector: 'prlw-all-table-column-header',
  templateUrl: './column-header.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllTableColumnHeaderContainer {
  @Input() public column!: AllTableColumn;
  public sorting$: Observable<AllTableSorting>;

  constructor(private readonly allTableService: AllTableService) {
    this.sorting$ = allTableService.allTableSorting$;
  }
}
